import CampaignApi from "../../services/api/Campaign";
import { getPath, pushOrUpdate, removeCondition } from "../../utils";
import ActionTypes from "./ActionTypes";
import { setLoader, setStatus } from "./User";
import Errors from "../../constants/Errors.json";
import SuccessMessages from "../../constants/SucessMessages.json";
import * as Comparators from "../../constants/FeatureToggle/Comparators";
import _ from "lodash-es";

function handleError(err) {
  console.error("error in campaign actions:", err);
}

export const setCampaignCitiesList = (payload) => {
  return {
    type: ActionTypes.SET_CAMPAIGN_CITIES,
    payload,
  };
};

export const resetState = (payload) => {
  return {
    type: ActionTypes.RESET_STATE_CAMPAIGN_CITIES,
    payload,
  };
};

export const getCampaignCitiesList = (campaignId) => async (dispatch) => {
  try {
    let campaignPayload = {
      campaign_id: campaignId,
    };
    _.unset(campaignPayload, ["filters", "serviceId"]);
    dispatch(setLoader(true));
    let response = await CampaignApi.getCampaignCities(campaignPayload);
    dispatch(setLoader(false));
    if (response) {
      dispatch(setCampaignCitiesList(response));
    }
  } catch (err) {
    dispatch(setLoader(false));
    dispatch(
      setStatus({
        type: "error",
        message: typeof err === "string" ? err : Errors.GENERAL_ERROR_1,
      })
    );
    handleError(err);
  }
};
